module.exports = __webpack_public_path__ + "static/media/LoyalityProgramCardsith.e80db7f7.png";